export default {
  formSettingsTitleContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  formSettingsTitle: { flex: 1 },
  formSettingsActionsContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  addButton: { color: 'white' },
};
